import { HttpHeaders } from "@angular/common/http"

export const endpoint = {

    // ECOMMERCE MODULE
    ECOMMERCE_PRODUCTS: 'Ecommerce',
    ECOMMERCE_PRODUCTS_FILTERS: 'Ecommerce/Filters',
    ECOMMERCE_PRODUCT_FILTER_OPTIONS: 'Ecommerce/FilterOptions',
    ECOMMERCE_PRODUCT_DETAIL: 'Ecommerce/',
    ECOMMERCE_SELECT_CATEGORIES: 'Ecommerce/ListCategories',

    //ORDERS MODULE    
    ORDER_REGISTER: 'Order',
    LIST_ORDER_BY_CLIENT: 'Order/Client?Id=',
    ORDER_BY_ID: 'Order/',

    //AUTH MODULE    
    LOGIN_GOOGLE_CLIENT: 'Auth/LoginWithGoogleClient',

    // PRODUCT MODULE
    PRODUCT_BY_ID: 'Product/',

    // CLIENT MODULE
    CLIENT_BY_ID: 'Client/',
    CLIENT_CURRENT_ACCOUNT: 'Client/',
    CLIENT_COMMERCIAL_SUMMARY: 'Client/',
    CLIENT_PURCHASE_HISTORY: 'Client/',
    CLIENT_REGISTER: 'Client',
    CLIENT_EDIT: 'Client/',

    // PRICE LIST MODULE
    PRICE_LIST_DEFAULT_BY_CLIENT: 'PriceList/Client/',
    
    // DOCUMENT TYPE MODULE
    LIST_DOCUMENT_TYPE: 'DocumentType',
}

export const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
}
